export const validatePassword = (password: string): boolean => {
  // 6文字以上
  if (password.length < 6) {
    return false
  }

  // 数字が含まれているか
  if (!/\d/.test(password)) {
    return false
  }

  // 小文字が含まれているか
  if (!/[a-z]/.test(password)) {
    return false
  }

  return true
}

export const PASSWORD_REQUIREMENT_MESSAGE =
  '6文字以上（半角英小文字・数字の両方を含む）'
